<template>
  <div class="flex items-center">
    <div class="flex flex-wrap w-full bg-white rounded border border-gray-200 focus-within:border-orange-500 shadow-sm transition-all"> 
      <slot name="search"/> 
      <div class="pr-3 lg:w-1/5 sm:w-full flex">
        <i class="fa fa-search text-orange-600"></i>
        <input class="relative px-4 py-2 w-full rounded-r focus:outline-none placeholder-gray-400 text-gray-700" autocomplete="off" type="text" name="search" placeholder="Search…" :value="modelValue" @input="$emit('update:modelValue', $event.target.value)" />   
      </div>
    </div> 
    
  </div>
  <slot name="stat"/>  
</template>

<script>
import Dropdownnew from '@/Shared/Dropdownnew'
import SelectInputSearch from '@/Shared/SelectInputSearch'
import ReIcon from '@/Shared/ReIcon'
import TextDatePicker from '@/Shared/TextDatePicker'
import SelectInput from '@/Shared/SelectInput'
import SelectInputFunction from '@/Shared/SelectInputFunction'
export default {
  components: {
    Dropdownnew,
    ReIcon,
    SelectInputSearch,
    TextDatePicker,
    SelectInput,
    SelectInputFunction
  },
  props: {
    modelValue: String,
    maxWidth: {
      type: Number,
      default: 300,
    },
  },
  emits: ['update:modelValue', 'reset'],
}
</script>
<style lang="scss" scoped>
  i{
    text-align: center;
    height: 33.33px;
    display: flex;
    align-items: center;
    padding-left: 15px;
  }
</style>